export default __webpack_public_path__ + "static/silveroute-balthazaurus-scroll-f98393f9c1ac5ef493f223229c3dc598.mp4";